import * as req from 'api/actions';
import * as c from './constant';

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    'api/v1/administrators/btax_billing_csv_imports',
    payload,
    callback
  );

export const upload = (payload = {}, callback) =>
  req.upload(
    c.UPLOAD,
    'api/v1/administrators/btax_billing_csv_imports/upload_csv',
    payload,
    callback
  );

  export const getUploadedList = (payload = {}, callback) =>
  req.list(
    c.UPLOAD_LIST,
    'api/v1/administrators/file_uploads',
    payload,
    callback
  );

  export const showUploaded = (id) =>
  req.item(
    c.SHOW_UPLOADED,
    `api/v1/administrators/file_uploads/${id}`
  );

  export const deleteFileUpload = (id, payload, callback) => req.remove(
    c.DELETE_FILE_UPLOAD,
    `api/v1/administrators/btax_billing_csv_imports/${id}`,
    payload,
    callback,
  );

  export const deleteFileHistoryUpload = (id, payload, callback) => req.remove(
    c.DELETE_FILE_HISTORY_UPLOAD,
    `/api/v1/administrators/file_uploads/${id}`,
    payload,
    callback,
  );

  // for Manual Import API (Smart City)
export const getListManualImport = (payload = {}, callback) =>
  req.list(
    c.LIST_MANUAL_IMPORT,
    'api/v1/administrators/btax_billing_manual_imports',
    payload,
    callback
  );

export const showManualImport = (id) =>
  req.item(
    c.SHOW_MANUAL_IMPORT,
    `api/v1/administrators/btax_billing_manual_imports/${id}`
  );

export const createRecordManualImport = (payload, callback) =>
  req.create(
    c.CREATE_RECORD_MANUAL_IMPORT,
    'api/v1/administrators/btax_billing_manual_imports',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data })
    }
  );

export const updateRecordManualImport = (id, payload, callback) =>
  req.update(
    c.UPDATE_RECORD_MANUAL_IMPORT,
    `api/v1/administrators/btax_billing_manual_imports/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data })
    }
  );

export const deleteRecordManualImport = (id, payload, callback) => 
  req.remove(
    c.DELETE_RECORD_MANUAL_IMPORT,
    `api/v1/administrators/btax_billing_manual_imports/${id}`,
    payload,
    callback,
  );
  
// export const getList = (payload = {}, callback) =>
//   req.list(
//     c.LIST,
//     'api/v1/administrators/btax_billing_csv_imports',
//     payload,
//     callback
//   );

